// packages/shared/src/utils/origin.ts

function getApiOrigin(): string {
  // These static references are required so CRA/Webpack can inline values.
  const EXPO_URL = process.env.EXPO_PUBLIC_DEVICE_IMAGE_ORIGIN; // mobile
  const REACT_URL = process.env.REACT_APP_API_URL; // CRA/Webpack
  const NEXT_URL = process.env.NEXT_PUBLIC_API_URL; // Next.js
  const VITE_URL = process.env.VITE_API_URL; // Vite

  // Fallback only if you actually proxy /api via the dev server
  const FALLBACK = typeof window !== 'undefined' ? window.location.origin : '';

  const base = (
    EXPO_URL ||
    REACT_URL ||
    NEXT_URL ||
    VITE_URL ||
    FALLBACK ||
    ''
  ).replace(/\/$/, '');
  if (!base) throw new Error('No API origin configured');
  return base;
}

/** Convert "/attachments/:id/view?...sig=..." to absolute URL.
 *  On web we go through "/api".
 */
export function toAbsoluteViewUrl(rel: string): string {
  let path = rel.startsWith('/') ? rel : `/${rel}`;
  if (path.startsWith('/attachments/')) path = `/api${path}`;
  return `${getApiOrigin()}${path}`;
}
